// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0de3f4fe","255":"2bb86f52","498":"953a8440","703":"923902d9","787":"00994eae"}[chunkId] + ".chunk.js";
};